'use strict';

define('lib/analytics/blocks/series.block',[], function () {
  function __buildCats(cats) {
    var localCats = cats;
    if (!localCats) {
      return '';
    }

    if (typeof localCats === 'string') {
      return localCats;
    }

    // always an ARR if we're here?
    // can be an array of strings, or an arr of objs with a name prop (as seen in PCM)
    localCats = cats.map(function (cat) {
      if (typeof cat === 'string') {
        return cat;
      }
      return cat.name;
    })
      .join(',');

    return localCats;
  }

  return function seriesBlock(series) {
    var providedDl = series.dataLayer;
    if (providedDl && providedDl.link_text) {
      delete providedDl.link_text;
    }
    return series.dataLayer || {
      series_code: series.series_code || '',
      series_year: series.year ? series.year.toString() : '',
      series_number: series.trim_code || '', // (model #) 1831
      series_vehicleid: series.vehicleid || '', // BRD_TOY-YR_2016-MDL_1831-XCOL_0218-ICOL_FB22-ACY_FE-ACY_QB
      series_inventory_type: 'New',
      series_brand: 'toyota',
      series_category: series.categories ? __buildCats(series.categories) : '',
      series_fuel_type: '',
      series_msrp: series.base_msrp ? series.base_msrp.toString() : '',
      series_grade: series.grade || '',
      series_engine: series.engine || '',
      series_transmission: series.transmission || '',
      series_body_style: '',
      series_packages: series.packages || '',
      series_color_ext: series.color_ext || '',
      series_color_int: series.color_int || '',
      series_color_ext_code: series.color_ext_code || '',
      series_color_int_code: series.color_int_code || '',
      series_accessories_name: series.accessories_name || '',
    };
  };
});

